import { z } from 'zod';

export const generalFormErrorMessage = 'Dit veld is verplicht';

export const addFuelTransactionSchema = z.object({
    transactionDate: z.coerce.string().min(1, {
        message: generalFormErrorMessage,
    }),
    litersOfFuel: z.coerce
        .number({
            required_error: generalFormErrorMessage,
        })
        .min(1, {
            message: 'Dit veld is verplicht en moet groter dan 0 zijn',
        }),
    amountIncludingVAT: z.coerce
        .number({
            required_error: generalFormErrorMessage,
        })
        .min(1, {
            message: 'Dit veld is verplicht en moet groter dan 0 zijn',
        }),
    kilometersTotal: z.coerce
        .number({
            required_error: generalFormErrorMessage,
        })
        .min(1, {
            message: 'Dit veld is verplicht en moet groter dan 0 zijn',
        }),
});
